export default __webpack_public_path__ + "b6971ee1b2f67760db2b34cd7d3f42a4.svg";